import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * Banner for a manager whose facility licence was suspended (PAUSED) by the
 * administration. The facility keeps read access, but creating or modifying
 * data is blocked until an administrator reactivates the licence — paying
 * does not lift a suspension, so there is no payment CTA: the manager is
 * pointed to support instead.
 */
export const SuspendedLicenceBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      data-testid="suspended-licence-banner"
      role="alert"
      className="flex flex-wrap items-center gap-3 px-6 py-4 border-b bg-warning-50 border-warning-200 text-warning-800"
    >
      <div className="flex-1 min-w-[200px]">
        <p className="text-sm font-semibold">{t("banner.suspended.title")}</p>
        <p className="text-xs mt-0.5 text-warning-700">
          {t("banner.suspended.subtitle")}
        </p>
      </div>
      <button
        onClick={() => navigate("/help-support")}
        className="px-4 py-2 text-sm font-medium text-white transition-colors rounded-lg bg-warning-600 hover:bg-warning-700"
      >
        {t("banner.suspended.cta")}
      </button>
    </div>
  );
};
